import { Button } from '@sgme/ui';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { sendHelpRequestThunk } from '@/api/help-request/index.ts';
import { useAppDispatch } from '@/store/hooks.ts';

export type ErrorTileProps = {
  errorCode?: string;
  errorDescription?: string;
  quoteId?: string;
  isModalOpen: boolean;
  multipassErrorCode?: string;
  setIsModalOpen: (isOpen: boolean) => void;
};

export const ErrorModal = (props: ErrorTileProps) => {
  const { errorCode, quoteId, errorDescription, isModalOpen, setIsModalOpen, multipassErrorCode } = props;
  const dispatch = useAppDispatch();

  const closeModal = () => setIsModalOpen(false);

  const sendHelpRequest = () => {
    dispatch(
      sendHelpRequestThunk({
        config: 'general',
        details: JSON.stringify({ error: errorCode, quoteId }),
      }),
    );

    closeModal();
  };

  return (
    <Modal
      show={isModalOpen}
      onHide={closeModal}
      centered
      contentClassName="border-danger"
      size="lg"
      data-e2e="error-detail-modal"
    >
      <div className="border border-danger">
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">
            <FormattedMessage id="tile.error.SGLogModal.tile" />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="d-flex flex-column" style={{ maxWidth: 464 }}>
          <div className="row flex-nowrap mb-3">
            <aside className="col-4">
              <FormattedMessage id="tile.error.SGLogModal.errorCode" />
            </aside>
            <div className="col-8 fw-bold" data-e2e="error-detail-code">
              {errorCode}
            </div>
          </div>

          <div className="row flex-nowrap mb-3">
            <aside className="col-4">
              <FormattedMessage id="tile.error.SGLogModal.reasonType" />
            </aside>
            <div className="col-8 fw-bold" data-e2e="error-detail-message">
              {errorDescription}
            </div>
          </div>

          <div className="row flex-nowrap mb-3">
            <aside className="col-4">
              <FormattedMessage id="tile.error.SGLogModal.multipassSessionId" />
            </aside>
            <div className="col-8 fw-bold" data-e2e="error-detail-mp-session-id">
              {quoteId}
            </div>
          </div>

          <div className="row flex-nowrap mb-3">
            <aside className="col-4">
              <FormattedMessage id="tile.error.SGLogModal.multipassErrorCode" />
            </aside>
            <div className="col-8 fw-bold" data-e2e="error-detail-mp-code">
              {multipassErrorCode}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button purpose="primary" onClick={sendHelpRequest} data-e2e="error-detail-send-help-request-btn">
            <FormattedMessage id="tile.error.sendHelpRequest" />
          </Button>

          <Button purpose="primary" color="secondary" onClick={closeModal} data-e2e="error-detail-close-btn">
            <FormattedMessage id="tile.error.close" />
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};
